var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationBellIndicator = function SvgNotificationBellIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.767 16.232v-1.915c-.132 0-.275.022-.407.022-3.61 0-6.372-2.763-6.372-6.373 0-1.771.671-3.345 1.783-4.479-.022 0-.044-.022-.066-.022v-.77a1.696 1.696 0 0 0-3.39 0v.77c-3.247.749-5.085 3.643-5.085 7.12v5.647l-1.452 1.452c-.716.716-.21 1.926.792 1.926h14.857c1.002 0 1.508-1.221.804-1.926l-1.453-1.452zM11.999 23a2.26 2.26 0 0 0 2.256-2.256H9.743A2.252 2.252 0 0 0 11.999 23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BA666",
    d: "M18.36 3.927c2.278 0 4.028 1.74 4.028 4.029 0 2.278-1.74 4.027-4.028 4.027-2.278 0-4.028-1.738-4.028-4.028 0-2.278 1.739-4.028 4.028-4.028"
  })));
};
export default SvgNotificationBellIndicator;